var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.versions},model:{value:(_vm.localVersion),callback:function ($$v) {_vm.localVersion=$$v},expression:"localVersion"}},'v-select',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }